if (!window.__productCardThumbnailsBound) {
  window.__productCardThumbnailsBound = true;

  document.addEventListener(
    'click',
    function (event) {
      var thumb = event.target.closest('.product-thumbnails .thumbnail');
      if (!thumb) return;

      event.preventDefault();
      event.stopPropagation();

      var card = thumb.closest('.card-wrapper');
      if (!card) return;

      card.querySelectorAll('.product-thumbnails .thumbnail').forEach(function (el) {
        el.classList.remove('selected-thumbnail');
      });
      thumb.classList.add('selected-thumbnail');

      var mainImageUrl = thumb.getAttribute('data-main-image');
      var media = card.querySelector('.media');
      if (!media || !mainImageUrl) return;

      media.innerHTML = '<img src="' + mainImageUrl + '" alt="" width="533" height="533">';
    },
    true
  );
}
